
import { Toast } from 'vant'

const baseURL = process.env.BASE_URL

const loading = function (message) {
  Toast.loading({
    duration: 0,
    forbidClick: true,
    message: message || '加载中...'
  })
}

const defaultImgPath = '/static/icon/XXXXX.gif' // 默认图片

const colorMainBlue = '#3f86ff'

export default {
  baseURL,
  defaultImgPath,
  loading,
  colorMainBlue
}



// WEBPACK FOOTER //
// ./src/utils/global.js